import { ThunkAction } from 'redux-thunk';
import { api2 } from '../apis';
import { HIPPA_FORM_SUBMITTED, HIPPA_FORM_SUBMITTING, HIPPA_FORM_FAILED, HIPPA_FORM_RESET } from 'store/types/hippa.type';
import { State } from 'store/reducers/auth.reducer';

const formSubmitting = () => ({ type: HIPPA_FORM_SUBMITTING });
const formSubmitted = (success: string) => ({ type: HIPPA_FORM_SUBMITTED, success });
const formFailed = (error: string) => ({ type: HIPPA_FORM_FAILED, error });
export const hippaFormReset = () => ({ type: HIPPA_FORM_RESET })

export type Actions =
  | ReturnType<typeof formSubmitting>
  | ReturnType<typeof formSubmitted>
  | ReturnType<typeof formFailed>
  | ReturnType<typeof hippaFormReset>;

type ThunkResult<R> = ThunkAction<R, State, undefined, Actions>;

export const submitHippaForm = (data: any, callback?: () => any): ThunkResult<void> => dispatch => {
  dispatch(formSubmitting());
  api2
    .post('/api/v2/provider_landing/upload_hippa_documents', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })(dispatch, false, true)
    .then(res => {
      dispatch(formSubmitted('Form submitted successfully!'))
      callback && callback()
    })
    .catch(err => dispatch(formFailed(err.message)))
};

export const updateDocumentStatus = (id: string): ThunkResult<void> => dispatch => {
  api2.patch(`/dashboard/home/${id}/update_document_status`)(dispatch, false, true)
    .then(() => null).catch(() => null)
} 